export default {
  Farm: {
    header: {
      create_farm: 'Registar Hacienda',
      action_unauthorized: 'No se le permite realizar esta acción.',
      field_text_suggestion: 'Vamos a crear los lotes de su hacienda ahora!',
      creation_question: 'Crear lotes?',
      farms: 'Haciendas',
    },
    import_fields_kml_card: {
      insufficient_coordinates: 'El lote {0} tiene coordenadas incorrectas',
      insufficient_polygons: 'Número insuficiente de polígonos',
      warning:
        'Formato KML desconocido o formateado sin especificaciones del sistema',
      no_field_latitude: 'El lote {0} no tiene latitudes',
      no_field_longitude: 'El lote {0} no tiene longitudes',
    },
    farm_card: {
      delete_farm_successfully: 'Hacienda eliminada con éxito',
      function_temporarily_unavailable: 'Función temporalmente no disponible',
      delete_farm_warning:
        'Al eliminar la hacienda, los programas asociados se perderán. Esta operación es irreversible.',
      which_channel_to_contact:
        '¿Con qué canal te gustaría ponerte en contacto?',
      excluir: 'Excluir',
      fields: 'Lotes',
      she_disabled: 'Desactivada',
      disable_farm_successfully: 'Hacienda deshabilitada con éxito.',
      enable_farm_successfully: 'Hacienda habilitada con éxito',
    },
    add_farm_modal: {
      edit_farm: 'Edición de hacienda',
      add_farm: 'Registro de hacienda',
      save_error: 'Error al guardar hacienda.',
      loading_error: 'Error al cargar haciendas.',
      city_error: 'Error al cargar municipios.',
      state_error: 'Error al cargar estados.',
      warning_create_farm: 'Al crear una hacienda serás redirigido a ella.',
      farm_name: 'Nombre de la Hacienda',
      type_here: 'Escribe aquí',
      country: 'País',
      select: 'Seleccione',
      states: 'Estados',
      cities: 'Municipios',
      required_price: 'Precio obligatorio',
    },
    fields_item_modal: {
      delete_field_warning:
        'Esta es una operación irreversible. Usted quiere excluir el lote?',
      enable_farm_error:
        'Ya no puedes habilitar haciendas y lotes. Si aún desea habilitarlo, comuníquese con nuestro equipo de soporte.',
      he_disabled: 'Desactivado',
      disable_field_successfully: 'Lote desabilitado con éxito.',
      enable_field_successfully: 'Lote habilitado con éxito.',
    },
    fields_modal: {
      add_fields: 'Registro de lotes',
      total: 'Total',
      done: 'Hecho',
      map_new_fields: 'Mapear nuevos lotes',
      add_field_description:
        'Usted puede agregar lotes a partir de archivos KML, o marcando el área del lote.',
      kml_format:
        'El archivo KML deve estar en el formato de Google y puede contener más de un lote.',
      load_kml: 'Cargar KML',
      or: 'o',
    },
    maps_modal: {
      field_name: 'Nombre del lote',
      remove_point: 'Quitar punto del mapa',
      search_latitude: 'Buscar latitude',
      search_longitude: 'Buscar longitude',
      save_field_warning:
        'Para guardar el lote, agregue al menos 3 puntos en el mapa',
      invalid_geometry:
        '¡Precaución! El diseño de campo debe representar una figura geométrica válida. Ajusta el mapa para completarlo. ',
      required_field: 'Campo obligatorio',
      field_map: 'Mapa del lote',
      save: 'Salvar',
      action_unauthorized: 'No se le permite realizar esta acción',
    },
    field_saved: 'Lote guardado con éxito.',
    msg_whatsapp_limit_enable_exceeded:
      '?text=%C2%A1Hola!+Quisiera+ayuda+porque+ya+no+puedo+habilitar+haciendas+y+lotes.+Uso+la+cuenta {0}.',
    edit: 'Editar',
    enable: 'Habilitar',
    disable: 'Deshabilitar',
    enable_field_warning:
      'Al deshabilitar el lote, no podrás crear nuevas siembras. ¿Aún deseas continuar?',
    disable_farm_warning:
      'Al deshabilitar el lote, no podrás crear nuevas siembras. ¿Aún deseas continuar?',
    get_in_touch: 'Entrar en contacto',
    area: 'Área',
    add: 'Agregar',
  },
}
